/**
 * CheckboxField — checkbox overlay for signing ceremony
 */

import type { FieldPlacement } from './types';

interface CheckboxFieldProps {
  placement: FieldPlacement;
  value: boolean;
  onChange: (checked: boolean) => void;
  fieldIndex: number;
}

export function CheckboxField({ placement, value, onChange, fieldIndex }: CheckboxFieldProps): JSX.Element {
  return (
    <label
      className="w-full h-full flex items-start justify-start cursor-pointer"
    >
      <input
        type="checkbox"
        data-testid={`checkbox-field-${fieldIndex}`}
        checked={value}
        onChange={(e) => onChange(e.target.checked)}
        aria-label={placement.label ?? 'Checkbox'}
        className="w-4 h-4 rounded border-primary/60 text-primary focus:ring-ring cursor-pointer"
      />
    </label>
  );
}

export default CheckboxField;
